import { render, staticRenderFns } from "./FormPanel.vue?vue&type=template&id=2236736a&scoped=true"
import script from "./FormPanel.vue?vue&type=script&lang=js"
export * from "./FormPanel.vue?vue&type=script&lang=js"
import style0 from "./FormPanel.vue?vue&type=style&index=0&id=2236736a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2236736a",
  null
  
)

export default component.exports